import { render, staticRenderFns } from "./gc-header-form-split.vue?vue&type=template&id=2f3cb4c5&scoped=true&"
import script from "./gc-header-form-split.vue?vue&type=script&lang=js&"
export * from "./gc-header-form-split.vue?vue&type=script&lang=js&"
import style0 from "./gc-header-form-split.vue?vue&type=style&index=0&id=2f3cb4c5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f3cb4c5",
  null
  
)

export default component.exports